import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../../services/admin.service';
import { LogService } from '../../../services/log.service';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmDialogService } from '../../../services/confirm-dialog.service';
import { AdminFacility } from '../../../types/admin/admin-facility';
import { AdminRole } from '../../../types/admin/admin-role';
import { AccessControlService } from '../../../services/access-control.service';
import { AdminPanel } from '../../../types/admin/admin-panel';
import { SessionService } from '../../../services/session.service';
import _ from 'lodash';

@Component({
  selector: 'app-admin-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.scss'],
  providers: [NgbDropdownConfig]
})
export class UserDetailsComponent implements OnInit {
  private static DETAILS = 1;
  private static FACILITIES = 2;
  private static ROLES = 3;
  private static PANELS = 4;
  activeTab = UserDetailsComponent.DETAILS;
  isSubmitted = false;
  isUserMXAdmin: boolean;

  constructor(
    public admin: AdminService,
    private log: LogService,
    private confirmDialog: ConfirmDialogService,
    public access: AccessControlService,
    private session: SessionService,
    config: NgbDropdownConfig
  ) {
    config.placement = 'bottom-right';
    config.autoClose = true;
  }

  ngOnInit() {
    this.admin.selectUserEvent.subscribe(() => {
      this.isSubmitted = false;
    });
    if (this.admin.isDevMode()) {
      //      this.activeTab = UserDetailsComponent.PANELS;
      // this.confirmDialog.open(
      //   'Close and loose updates?',
      //   'Proceed',
      //   'Cancel',
      //   () => {
      //     this.log.trace('accepted');
      //   }
      // );
    }
    this.isUserMXAdmin=this.session.getUser().isMxAdmin;
    this.log.trace("oninit, isUserMXAdmin="+this.isUserMXAdmin);
  }

  setActiveTab(tab: number) {
    this.activeTab = tab;
  }

  onClose() {
    this.log.trace('AdminUserDetails.onClose');
    this.admin.setSelectedUser(null);
  }

  onFacilityChange(fac: AdminFacility, checked: boolean) {
    const user = this.admin.getSelectedUser();
    this.log.trace('UserDetails.onFacilityChange.before', {
      facility: fac,
      selected: checked,
      user: user
    });
    checked ? user.addFacility(fac) : user.removeFacility(fac);
    user.IsChanged = true;
    this.log.trace('UserDetails.onFacilityChange.after', {
      user: user
    });
  }

  onRoleChange(app: AdminRole, checked: boolean) {
    const user = this.admin.getSelectedUser();
    this.log.trace('UserDetails.onRoleChange.before', {
      app: app,
      checked: checked,
      user: user
    });
    checked ? user.addRole(app) : user.removeRole(app);
    user.IsChanged = true;
    this.log.trace('UserDetails.onRoleChange.after', {
      user: user
    });
  }

  onPanelChange(panel: AdminPanel, checked: boolean) {
    const user = this.admin.getSelectedUser();
    this.log.trace('UserDetails.onPanelChange.before', {
      panel: panel,
      checked: checked,
      user: user
    });
    checked ? user.addPanel(panel) : user.removePanel(panel);
    user.IsChanged = true;
    this.log.trace('UserDetails.onPanelChange.after', {
      user: user
    });
  }

  onChange(trace: boolean) {
    this.admin.getSelectedUser().IsChanged = true;
    if (trace) {
      this.log.trace('UserDetails.onChange', this.admin.getSelectedUser());
    }
  }

  onSave() {
    this.log.trace('AdminUserDetails.onSave', this.admin.getSelectedUser());
    this.isSubmitted = true;
    this.admin.saveUser();
  }

  isDetailsActive(): boolean {
    return this.activeTab === UserDetailsComponent.DETAILS;
  }

  isFacilitiesActive(): boolean {
    return this.activeTab === UserDetailsComponent.FACILITIES;
  }

  isRolesActive(): boolean {
    return this.activeTab === UserDetailsComponent.ROLES;
  }

  isPanelsActive(): boolean {
    return this.activeTab === UserDetailsComponent.PANELS;
  }

  getActiveClass(tab: number): string {
    if (tab === this.activeTab) {
      return 'active';
    }
    return '';
  }

  resendWelcome() {
    this.confirmDialog.open(
      `Resend welcome invite to ${this.admin.getSelectedUser().getFullName()}?`,
      'Proceed',
      'Cancel',
      () => {
        this.log.trace('UserDetails.resendWelcome.onAccept');
        this.admin.actionResendWelcome();
      }
    );
  }

  resetPassword() {
    this.confirmDialog.open(
      `Reset password for ${this.admin.getSelectedUser().getFullName()}?`,
      'Proceed',
      'Cancel',
      () => {
        this.log.trace('UserDetails.resetPassword.onAccept');
        this.admin.actionResetPassword();
      }
    );
  }

  disableMFA() {
    this.confirmDialog.open(
      `Disable MFA for ${this.admin.getSelectedUser().getFullName()}?`,
      'Proceed',
      'Cancel',
      () => {
        this.log.trace('UserDetails.disableMFA.onAccept');
        this.admin.actionDisableMFA();
      }
    );
  }

  enableMFA() {
    this.confirmDialog.open(
      `Enable MFA for ${this.admin.getSelectedUser().getFullName()}?`,
      'Proceed',
      'Cancel',
      () => {
        this.log.trace('UserDetails.enableMFA.onAccept');
        this.admin.actionEnableMFA();
      }
    );
  }

  lock() {
    this.confirmDialog.open(
      `Lock account for ${this.admin.getSelectedUser().getFullName()}?`,
      'Proceed',
      'Cancel',
      () => {
        this.log.trace('UserDetails.lock.onAccept');
        this.admin.actionLockUser();
      }
    );
  }

  unlock() {
    this.confirmDialog.open(
      `Unlock account for ${this.admin.getSelectedUser().getFullName()}?`,
      'Proceed',
      'Cancel',
      () => {
        this.log.trace('UserDetails.unlock.onAccept');
        this.admin.actionUnlockUser();
      }
    );
  }

  activate() {
    this.confirmDialog.open(
      `Are you sure you want to activate the account?`,
      'Proceed',
      'Cancel',
      () => {
        this.log.trace('UserDetails.activate.onAccept');
        this.admin.actionActivateUser();
      }
    );
  }

  deactivate() {
    this.confirmDialog.open(
      `Are you sure you want to deactivate the account?`,
      'Proceed',
      'Cancel',
      () => {
        this.log.trace('UserDetails.deactivate.onAccept');
        this.admin.actionDeactivateUser();
      }
    );
  }

  canSaveUser() {
    const user = this.session.getUser();
    return user.isMxAdmin || user.isOrgAdmin || user.isFacAdmin;
  }

  onToggleDEAVisibility() {
    let deaInput = (<HTMLInputElement>document.getElementById("dea"));
 
    if (deaInput.classList.contains('input-field-mask')) {
      deaInput.classList.remove('input-field-mask');
    } else {
      deaInput.classList.add('input-field-mask');
    }
  }
}
